var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"p-2"},[_c(_vm.editor,{tag:"component",attrs:{"data":_vm.item,"contentType":_vm.contentType}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }